export const Arrow = () => {
    return (
        <svg className={"arrow-icon"} width="16" height="16" viewBox="0 0 16 16">
            <path
                d="M7.025-6.154l-.871-.871,13.9-13.9H11.077v-1.231H22.154v11.077H20.923v-8.975Z"
                transform="translate(-6.154 22.154)"
            />
        </svg>
    );
};
